<template>
  <v-card v-if="torneo" class="mb-4 pa-4">
    <v-card-title class="text-h6 font-weight-bold align-center">
      {{ torneo.torneo.nombreTorneo }}
    </v-card-title>

    <v-divider class="mt-3"></v-divider>

    <v-card-text class="text-body-2">
      <v-row dense>
        <!-- Fecha de entrega de listas -->
        <v-col cols="12" sm="6" class="d-flex align-center">
          <v-icon class="me-2" color="blue">mdi-calendar-clock</v-icon>
          <span
            ><strong>Fin entrega de listas:</strong>
            {{ formatDate(torneo.torneo.fechaEntregaListas) }}</span
          >
        </v-col>

        <!-- Inicio inscripción -->
        <v-col cols="12" sm="6" class="d-flex align-center">
          <v-icon class="me-2" color="green">mdi-calendar-plus</v-icon>
          <span
            ><strong>Inicio de inscripción:</strong>
            {{ formatDate(torneo.torneo.inicioInscripciones) }}</span
          >
        </v-col>

        <!-- Fin de inscripción -->
        <v-col cols="12" sm="6" class="d-flex align-center">
          <v-icon class="me-2" color="red">mdi-calendar-remove</v-icon>
          <span
            ><strong>Fin de inscripción:</strong>
            {{ formatDate(torneo.torneo.fechaFinInscripcion) }}</span
          >
        </v-col>

        <!-- Equipos inscritos -->
        <v-col cols="12" sm="6" class="d-flex align-center">
          <v-icon class="me-2" color="yellow">mdi-account-group</v-icon>
          <span
            ><strong>{{
              esParejas ? "Parejas inscritas:" : "Equipos inscritos:"
            }}</strong>
            {{ totalEquipos }}</span
          >
        </v-col>

        <!-- Plazas restantes -->
        <v-col cols="12" sm="6" class="d-flex align-center">
          <v-icon class="me-2" color="orange">mdi-seat-outline</v-icon>
          <span><strong>Plazas restantes:</strong> {{ plazasRestantes }}</span>
        </v-col>

        <!-- Pagos realizados -->
        <v-col cols="12" sm="6" class="d-flex align-center">
          <v-icon class="me-2" color="green">mdi-cash-multiple</v-icon>
          <span
            ><strong>Pagos:</strong> {{ pagosRealizados }}/{{
              totalEquipos
            }}</span
          >
        </v-col>

        <!-- Listas entregadas -->
        <v-col cols="12" sm="6" class="d-flex align-center">
          <v-icon class="me-2" color="blue">mdi-file-document</v-icon>
          <span
            ><strong>Listas entregadas:</strong> {{ listasEntregadas }}/{{
              totalListas
            }}</span
          >
        </v-col>

        <!-- Listas legales -->
        <v-col cols="12" sm="6" class="d-flex align-center">
          <v-icon class="me-2" color="purple">mdi-file-check</v-icon>
          <span
            ><strong>Listas legales:</strong> {{ listasLegales }}/{{
              totalListas
            }}</span
          >
        </v-col>
      </v-row>
    </v-card-text>
    <v-divider class="my-2" />

    <!-- Los mismos botones en todas las gestiones: uno por fila y a lo ancho -->
    <v-card-actions>
      <v-row>
        <v-col cols="12">
          <v-btn
            variant="tonal"
            color="secondary"
            @click="modificarTorneo"
            block
            >Modificar torneo</v-btn
          >
        </v-col>
        <v-col cols="12">
          <v-btn
            variant="tonal"
            color="secondary"
            @click="modificarBasesTorneo"
            block
            >Modificar bases</v-btn
          >
        </v-col>

        <v-col cols="12">
          <v-btn
            variant="tonal"
            color="secondary"
            @click="handlerMostrarListas"
            block
            >{{ mostrarListas ? "Ocultar" : "Mostrar" }} Listas</v-btn
          >
        </v-col>

        <v-col cols="12">
          <v-btn
            variant="tonal"
            color="secondary"
            @click="handlerMostrarClasificacion"
            block
            >{{
              mostrarClasificacion ? "Ocultar" : "Mostrar"
            }}
            Clasificación</v-btn
          > </v-col
        ><v-col cols="12">
          <v-btn
            variant="tonal"
            color="secondary"
            @click="descargarListasTorneo"
            block
          >
            Descargar Listas</v-btn
          >
        </v-col>
        <!-- Acciones propias de la gestión, justo debajo: generar la ronda 1 y el sorteo -->
        <slot name="acciones" />
      </v-row>
    </v-card-actions>
    <v-card-text>
      <CardAddTorneoCircuito :idTorneo="props.torneo?.torneo.idTorneo!" />
    </v-card-text>
  </v-card>

  <!-- modal para modificar el torneo -->
  <ModalModificarTorneo
    :isVisible="showModificarTorneoModal"
    :torneo="torneoMod"
    @close="cerrarModal()"
  />

  <!-- modal para modificar el torneo -->
  <ModalModificarBasesTorneo
    :isVisible="showModificarBasesTorneoModal"
    :torneo="torneoMod"
    @close="cerrarModal()"
  />

  <!-- modal para manejar mostrar listas del torneo -->
  <ModalHandlerMostrarListas
    :isVisible="showModalHandlerMostrarListas"
    :torneo="torneoMod"
    @close="cerrarModal()"
    @confirm="onCambioMostrarListas"
  />

  <!-- modal para manejar mostrar listas del torneo -->
  <ModalHandlerMostrarClasificacion
    :isVisible="showModalHandlerMostrarClasificacion"
    :torneo="torneoMod"
    @close="cerrarModal()"
    @confirm="onCambioMostrarClasificacion"
  />
  <!-- modal torneo modificado con exito -->
  <ModalSuccess
    :isVisible="showSuccessModal"
    message="Torneo modificado con éxito."
    @update:isVisible="showSuccessModal = $event"
  />
  <!-- modal Error al modificar el torneo -->
  <ModalError
    :isVisible="showErrorModal"
    message="No se han podido modificar el torneo. Intentalo de nuevo y si el error persiste contacta con el administrador."
    @update:isVisible="showErrorModal = $event"
  />
  <LoadingLOTR
    :isVisible="isDownloading"
    mensaje="Generando PDF, por favor espera..."
  >
    <template #default>
      <div v-if="isDownloading" style="margin-top: 10px">
        <div style="text-align: center; font-size: 12px; margin-top: 4px">
          {{ progressPDF }}%
        </div>
      </div>
    </template>
  </LoadingLOTR>
</template>

<script setup lang="ts">
import { Torneo } from "@/interfaces/Torneo";
import { computed, ref, watch } from "vue";
import { getListasTorneoAsync, getTorneo } from "@/services/TorneosService";
import ModalModificarBasesTorneo from "../ModalModificarBasesTorneo.vue";
import ModalModificarTorneo from "../ModalModificarTorneo.vue";
import { TorneoEquipoGestionInfoDTO } from "@/interfaces/Inscripcion";
import ModalHandlerMostrarListas from "../ModalHandlerMostrarListas.vue";
import ModalHandlerMostrarClasificacion from "../ModalHandlerMostrarClasificacion.vue";
import CardAddTorneoCircuito from "../CardAddTorneoCircuito.vue";
import { ClassificationType } from "@/Constant/TipoClasificacion";
import LoadingLOTR from "@/components/Commons/LoadingLOTR.vue";
import ModalError from "@/components/Commons/ModalError.vue";
import ModalSuccess from "@/components/Commons/ModalSuccess.vue";
import { ListaCompletaDTO } from "@/interfaces/Lista";
import jsPDF from "jspdf";
import { descargarListasPDF } from "@/utils/descargarListas";

// eslint-disable-next-line no-undef
const props = defineProps<{ torneo: TorneoEquipoGestionInfoDTO | null }>();
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const showModificarTorneoModal = ref<boolean>(false);
const showModificarBasesTorneoModal = ref<boolean>(false);
const showModalHandlerMostrarListas = ref<boolean>(false);
const showModalHandlerMostrarClasificacion = ref<boolean>(false);

const mostrarClasificacion = ref(props.torneo?.torneo.mostrarClasificacion);
const mostrarListas = ref(props.torneo?.torneo.mostrarListas);

const progressPDF = ref<number>(0);

watch(
  () => props.torneo?.torneo.mostrarListas,
  nuevoValor => {
    mostrarListas.value = nuevoValor;
  }
);

watch(
  () => props.torneo?.torneo.mostrarClasificacion,
  nuevoValor => {
    mostrarClasificacion.value = nuevoValor;
  }
);

const idTorneo = ref<number>(0);
const isLoading = ref<boolean>(false);
const isDownloading = ref<boolean>(false);
const torneoMod = ref<Torneo>({
  idTorneo: 0,
  idUsuario: 0,
  nombreTorneo: "",
  descripcionTorneo: "",
  fechaInicioTorneo: "",
  fechaFinTorneo: "",
  precioTorneo: 0,
  numeroPartidas: 0,
  puntosTorneo: 0,
  estadoTorneo: "ESPERANDO",
  lugarTorneo: "",
  tipoTorneo: "Individual",
  esPrivadoTorneo: false,
  idRangoTorneo: 0,
  esMatchedPlayTorneo: false,
  fechaEntregaListas: "",
  fechaFinInscripcion: "",
  basesTorneo: "",
  cartelTorneo: "",
  metodosPago: [],
  horaInicioTorneo: "",
  horaFinTorneo: "",
  tieneBases: false,
  inicioInscripciones: "",
  listasPorJugador: 0,
  mostrarListas: false,
  mostrarClasificacion: false,
  classificationType: ClassificationType.NORMAL,
});

const plazasRestantes = computed(() => {
  if (!props.torneo || props.torneo.torneo.limiteParticipantes === null) {
    return "Sin límite";
  }
  if (props.torneo.torneo.limiteParticipantes) {
    return props.torneo.torneo.limiteParticipantes - totalEquipos.value;
  }
  return "Sin límite";
});

const totalEquipos = computed(() => {
  return props.torneo ? props.torneo.equipos.length : 0;
});

const jugadoresXEquipo = computed(() => {
  return props.torneo ? props.torneo.torneo.jugadoresXEquipo : 0;
});

const totalJugadores = computed(() => {
  return totalEquipos.value * jugadoresXEquipo.value;
});

const esParejas = computed(() => props.torneo?.torneo.tipoTorneo === "Parejas");
// Con lista conjunta cada pareja entrega una sola lista, aunque marque entregada a los dos
const esListaConjunta = computed(
  () => esParejas.value && props.torneo?.torneo.listaPorPareja === true
);

const totalListas = computed(() =>
  esListaConjunta.value ? totalEquipos.value : totalJugadores.value
);

const pagosRealizados = computed(() => {
  if (!props.torneo) return 0;
  return props.torneo.equipos.filter(equipo => equipo.esPago === "SI").length;
});

const listasLegales = computed(() => {
  if (!props.torneo) return 0;
  return props.torneo.equipos.reduce((contador, equipo) => {
    // Para cada equipo, contamos cuántas inscripciones cumplen con los estados
    const listas = equipo.inscripciones.filter(
      lista => lista.estadoLista === "OK"
    ).length;

    if (esListaConjunta.value) return contador + (listas > 0 ? 1 : 0);

    // Sumamos el número de listas válidas al contador
    return contador + listas;
  }, 0);
});

const listasEntregadas = computed(() => {
  if (!props.torneo) return 0;

  return props.torneo.equipos.reduce((contador, equipo) => {
    // Para cada equipo, contamos cuántas inscripciones cumplen con los estados
    const listas = equipo.inscripciones.filter(
      lista =>
        lista.estadoLista === "OK" ||
        lista.estadoLista === "ENTREGADA" ||
        lista.estadoLista === "ILEGAL"
    ).length;

    if (esListaConjunta.value) return contador + (listas > 0 ? 1 : 0);

    // Sumamos el número de listas válidas al contador
    return contador + listas;
  }, 0);
});

const formatDate = (date: string | null | undefined) => {
  if (!date) return "N/A";
  return new Date(date).toLocaleDateString();
};

const modificarTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModificarTorneoModal.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const modificarBasesTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModificarBasesTorneoModal.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const handlerMostrarListas = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModalHandlerMostrarListas.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

const handlerMostrarClasificacion = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    const responseTorneo = await getTorneo(idTorneo.value);
    torneoMod.value = responseTorneo.data;
    showModalHandlerMostrarClasificacion.value = true;
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    isLoading.value = false;
    showErrorModal.value = false;
  }
};

function chunkArray<T>(arr: T[], size: number): T[][] {
  const result: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

const descargarListasTorneo = async () => {
  if (
    props.torneo?.torneo.idTorneo != undefined &&
    props.torneo?.torneo.idTorneo != 0 &&
    props.torneo?.torneo.idTorneo != null
  )
    idTorneo.value = props.torneo?.torneo.idTorneo;

  try {
    isDownloading.value = true;
    const response = await getListasTorneoAsync(idTorneo.value);
    const listas: ListaCompletaDTO[] = response.data;
    await descargarListasPDF(
      listas,
      props.torneo?.torneo.nombreTorneo ?? "",
      jugadoresXEquipo.value,
      (current, total) => { progressPDF.value = Math.round((current / total) * 100); }
    );
  } catch (error) {
    console.error(error);
    showErrorModal.value = true;
  } finally {
    progressPDF.value = 0;
    isDownloading.value = false;
    showErrorModal.value = false;
  }
};

const cerrarModal = async () => {
  showModificarBasesTorneoModal.value = false;
  showModalHandlerMostrarListas.value = false;
  showModalHandlerMostrarClasificacion.value = false;

  showModificarTorneoModal.value = false;
};

const onCambioMostrarListas = (nuevoValor: boolean) => {
  mostrarListas.value = nuevoValor;
  showModalHandlerMostrarListas.value = false;
};

const onCambioMostrarClasificacion = (nuevoValor: boolean) => {
  mostrarClasificacion.value = nuevoValor;
  showModalHandlerMostrarClasificacion.value = false;
};
</script>
<style scoped>
.responsive-text {
  font-size: 16px; /* Tamaño base */
  text-align: center;
}

@media (max-width: 768px) {
  .responsive-text {
    font-size: 14px; /* Tamaño más pequeño para móviles */
  }
}

@media (max-width: 480px) {
  .responsive-text {
    font-size: 12px; /* Ajuste adicional para pantallas muy pequeñas */
  }
}
</style>
